/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Nav_PermissionsInputs */

const en_admin_nav_permissions = /** @type {(inputs: Admin_Nav_PermissionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permissions`)
};

/**
* | output |
* | --- |
* | "Permissions" |
*
* @param {Admin_Nav_PermissionsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_nav_permissions = /** @type {((inputs?: Admin_Nav_PermissionsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Nav_PermissionsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_nav_permissions(inputs)
});
export { admin_nav_permissions as "admin.nav.permissions" }